import createQueryParamsForGetReq from 'helper/createQueryParamsForGetReq';
import { useQuery } from 'react-query';

import apiEndPoints from 'services/apiEndPoints';
import makeApiRequest from 'services/makeApiRequest';

export default function useGetemployeeblogs({
  BlogId,
  isDeleted,
  isDraft,
  searchText,
  filterYear,
}) {
  return useQuery(
    ['get-employee-blog-data', isDeleted, isDraft, searchText, filterYear],
    async () => {
      const response = await makeApiRequest.get(
        createQueryParamsForGetReq(apiEndPoints.EMPLOYEE_BLOG_API, {
          is_deleted: isDeleted,
          is_draft: isDraft,
          id: BlogId,
          search: searchText,
          created_date__year: filterYear,
        })
      );

      return response.data;
    }
  );
}
